var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { MenuList as MuiMenuList, Typography, } from '@mui/material';
import ListItem from '../ListItem/ListItem';
var MenuList = function (_a) {
    var title = _a.title, titleIcon = _a.titleIcon, scrollable = _a.scrollable, maxHeight = _a.maxHeight, children = _a.children, sx = _a.sx, props = __rest(_a, ["title", "titleIcon", "scrollable", "maxHeight", "children", "sx"]);
    return (React.createElement(MuiMenuList, __assign({ sx: __assign({ maxHeight: maxHeight !== null && maxHeight !== void 0 ? maxHeight : 'none', overflowY: scrollable ? 'scroll' : 'unset', outline: 'none' }, sx) }, props),
        title || titleIcon ? (React.createElement(ListItem, { startIcon: titleIcon, sx: { pointerEvents: 'none', minHeight: '2.5rem', paddingY: 0.875 } },
            React.createElement(Typography, { variant: "heading4", sx: { fontWeight: 'bold' } }, title))) : null,
        children));
};
export default MenuList;
//# sourceMappingURL=MenuList.js.map